/**
 * Created by Christof Sander on 07.02.2017.
 */

var utils = require('../lib/utils');
window.jQuery = window.$ = utils.$ = require('jquery');
utils.i18next.wrapper = require('./i18next');
// utils.i18next.resource = require("i18next-resource-store-loader!translations");
module.exports = utils;